export const getProductsBySkuList = (products, productListFilter) => {
  let resultProductsFilter = []

  productListFilter.forEach(item => {
    let filter = products[item]
    if (filter) resultProductsFilter.push(filter)
  })

  return resultProductsFilter
}

export const getProductsBySkuListWithAvailability = (
  products,
  productListFilter
) => {
  let resultProductsFilter = []

  productListFilter.forEach(item => {
    let filter = products[item]
    if (filter) {
      resultProductsFilter.push(filter)
    }
  })

  return resultProductsFilter
}

export const getProductsBySku = (products, sku) => {
  return products[sku]
}

export const getAvailabilityBySku = (availabilities, sku) => {
  return availabilities[sku]
}



// WEBPACK FOOTER //
// ./src/features/Products/selector.js